function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import sumBy from "lodash/sumBy";
import differenceInCalendarWeeks from "date-fns/difference_in_calendar_weeks";
/**
 *
 * @param domElement
 */ export var getElementWindowTop = function(domElement) {
    return domElement.getBoundingClientRect().y + window.scrollY;
};
/**
 * @typedef {Object} ChartSpecs
 * @property {Object[]} barGroups
 * @property {number[]} barGroups[].indexPath
 * @property {number} barGroups[].startWeek
 * @property {number[]} barGroups[].weekCounts
 * @property {number} totalWeeks
 */ /**
 *
 * @param {Array<import('../GanttView').ItemGroup>} itemGroups
 * @returns {ChartSpecs}
 */ export var getChartSpecs = function(itemGroups) {
    var _Math, _Math1;
    var COLOR_PALETTE = [
        "#FFBF00",
        "#5DD2BC",
        "#FF6040",
        "#C18CD3"
    ];
    var getNthColor = function(i) {
        return COLOR_PALETTE[i % COLOR_PALETTE.length];
    };
    var barGroups = [];
    itemGroups.forEach(function(group, gi) {
        group.itemRows.forEach(function(row, ri) {
            var ref;
            var startDateStr = row.item.values[(ref = row.item.rows.find(function(r) {
                return r.rowType === "datepicker";
            })) === null || ref === void 0 ? void 0 : ref.id];
            var startDate = startDateStr && new Date(startDateStr);
            var phases = row.phasesBreakdown.phases;
            var allPhases = row.allPhases;
            var allPhasesWithIndex = allPhases.reduce(function(acc, val, ind) {
                acc[val] = ind;
                return acc;
            }, {});
            var weekCounts = phases.map(function() {
                return 1;
            });
            var weekBarIndexes = phases.map(function(phase) {
                return allPhasesWithIndex[phase];
            });
            barGroups.push({
                indexPath: [
                    gi,
                    ri
                ],
                startDate: startDate,
                weekCounts: weekCounts,
                weekBarIndexes: weekBarIndexes,
                color: getNthColor(ri),
                startWeek: 0
            });
        });
    });
    var today = new Date();
    var firstStart = (_Math = Math).min.apply(_Math, _toConsumableArray(barGroups.map(function(bg) {
        return bg.startDate || today;
    })));
    // @refactor
    barGroups.forEach(function(bg) {
        var startDate = bg.startDate || firstStart;
        bg.startWeek = differenceInCalendarWeeks(startDate, firstStart, {
            weekStartsOn: 1
        });
    });
    var totalWeeks = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(barGroups.map(function(bg) {
        return (bg.startWeek || 0) + sumBy(bg.weekCounts);
    })));
    return {
        barGroups: barGroups,
        totalWeeks: totalWeeks
    };
};
